// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"e883f223025cbbcc7c215793c862f568","531":"bde7d432713268d9f295a44a9a0209c4"}[chunkId] + ".js";
};